<template>
  <div class="ui fixed sidebar vertical menu left">
    <PageLinks class="ui container" />
  </div>
</template>

<script>
import PageLinks from './pagelinks.vue';

export default {
  name: 'Sidebar',
  props: [],
  components: {
    PageLinks,
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#sidebar {
  z-index: 100;
  width: 200px;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.02);
  overflow-y: hidden !important;
}

#sidebar .ui.container {
  margin: 60px 0 0;
  display: block;
  height: 100%;
  overflow-y: auto;
}
</style>
